import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var _excluded = ["render"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import NavigationConstants from '../../components/LobbyOverlay/NavigationConstants';
export var PAGE_SIZE = 8;
var Home = /*#__PURE__*/function (_Component) {
  function Home() {
    var _this;
    _classCallCheck(this, Home);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Home, [].concat(args));
    _this.processGames = function () {
      var _slotGames$gameList;
      var _this$props = _this.props,
        slotGames = _this$props.slotGames,
        userLevel = _this$props.userLevel,
        gameInfo = _this$props.gameInfo;
      if (!(slotGames !== null && slotGames !== void 0 && (_slotGames$gameList = slotGames.gameList) !== null && _slotGames$gameList !== void 0 && _slotGames$gameList.length)) return {
        panelList: [],
        pagedGames: [],
        pageNumber: 0,
        gameIndex: 0
      };
      var panelList = slotGames.gameList[0].games.filter(function (game) {
        return !game.IS_HIDDEN;
      });
      var pagedGames = [];
      var pageNumber = 0;
      var gameIndex = 0;
      var getGameIndex = function getGameIndex(pageIndex, gameIndexOnPage) {
        var gamesPerRow = PAGE_SIZE / 2;
        var baseIndex = pageIndex * gamesPerRow;
        var indexWithinRow = gameIndexOnPage % gamesPerRow;
        return baseIndex + indexWithinRow;
      };
      pagedGames = panelList.reduce(function (acc, curr, index) {
        var pageIndex = Math.floor(index / PAGE_SIZE);
        if (!acc[pageIndex]) acc[pageIndex] = [];
        acc[pageIndex].push(curr);
        return acc;
      }, []).map(function (gamePage) {
        var _gamePage$reduce = gamePage.reduce(function (_ref, game, index) {
            var _ref2 = _slicedToArray(_ref, 2),
              even = _ref2[0],
              odd = _ref2[1];
            (index % 2 === 0 ? even : odd).push(game);
            return [even, odd];
          }, [[], []]),
          _gamePage$reduce2 = _slicedToArray(_gamePage$reduce, 2),
          evenIndexItems = _gamePage$reduce2[0],
          oddIndexItems = _gamePage$reduce2[1];
        return [].concat(_toConsumableArray(evenIndexItems), _toConsumableArray(oddIndexItems));
      });
      pagedGames.some(function (page, pageIndex) {
        return page.some(function (game, gameIndexOnPage) {
          if (game.GAME_ID === gameInfo.lastGameVisited) {
            pageNumber = pageIndex;
            gameIndex = getGameIndex(pageIndex, gameIndexOnPage);
            return true;
          } else if (game.UNLOCK_LEVEL <= userLevel) {
            pageNumber = pageIndex;
            gameIndex = getGameIndex(pageIndex, gameIndexOnPage) - 1;
          }
          return false;
        });
      });
      return {
        panelList: panelList,
        pagedGames: pagedGames,
        pageNumber: pageNumber,
        gameIndex: gameIndex
      };
    };
    return _this;
  }
  _inherits(Home, _Component);
  return _createClass(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setNavState(NavigationConstants.NO_HIDE);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        render = _this$props2.render,
        props = _objectWithoutProperties(_this$props2, _excluded);
      var _this$processGames = this.processGames(),
        panelList = _this$processGames.panelList,
        pagedGames = _this$processGames.pagedGames,
        pageNumber = _this$processGames.pageNumber,
        gameIndex = _this$processGames.gameIndex;
      return render(_objectSpread({
        panelList: panelList,
        numColumn: 1,
        pagedGames: pagedGames,
        pageNumber: pageNumber,
        gameIndex: gameIndex
      }, props));
    }
  }]);
}(Component);
export { Home as default };